import { useState } from 'react';
import createUrl, { DOMAIN } from '../urlCreator/urlCreator';

/**
 * スマホ用のso-net共通ヘッダー
 * ヘッダー用script（https://www.so-net.ne.jp/common/hf1704/js/header.js）のうち関係あるものだけ実装
 */
const CommonHeaderForSmartPhone = () => {
    const [closed, setClosed] = useState(true);
    const toggleClosed = () => setClosed(!closed);

    const style = {
        overflow: 'hidden',
        height: closed ? 0 : 113,
        transition: '0.4s',
        display: 'block',
    };

    return (
        <>
            <div className="gHd2017_header gHd2017_SP">
                <div className="gHd2017_sonyHeader">
                    <span className="gHd2017_sonyHeaderInner">
                        <a href={'https://www.sony.co.jp/'}>
                            <img
                                itemProp="logo"
                                src={createUrl(DOMAIN.SONET, '/common/hf1704/img/logo-sony.png')}
                                alt="Sony"
                            />
                        </a>
                    </span>
                </div>

                <noscript className="gHd2017_noscript">
                    このページはJavaScriptを使用しています。JavaScriptを有効にしてご覧ください。
                </noscript>

                <div className="gHd2017_headerInner">
                    <div className="gHd2017_logoWrapper">
                        <div itemType="http://schema.org/Organization" className="gHd2017_logo">
                            <a itemProp="url" href={createUrl(DOMAIN.SONET, '/?SmRcid=gn_hd_slogo')}>
                                <img
                                    itemProp="logo"
                                    src={createUrl(DOMAIN.SONET, '/common/hf1704/img/logo.png')}
                                    alt="So-net"
                                />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="gHd2017_parsonal" />
            </div>
           
        </>
    );
};

export default CommonHeaderForSmartPhone;
